export default __webpack_public_path__ + "img/fyaXAnPV.2fa6722b.svg";